import { Box, Button, Fade } from "@mui/material";
import LockClockRoundedIcon from "@mui/icons-material/LockClockRounded";
import LoginIcon from "@mui/icons-material/Login";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PublicFormButton, PublicFormCard } from "../components/common/form/PublicFormCard";
import { removeLoggedInUser } from "../modules/common/user/UserService";
import { MESSAGES } from "../modules/common/shared/messages";
import { useAuth } from "../auth/AuthContext";

/** Shown when the login token expires (timer in useSessionExpiry, or a 401 from the backend). */
export const SessionExpiredPage = () => {
  const { setUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    removeLoggedInUser();
    setUser(null);
  }, [setUser]);

  return (
    // Like Logout: outside PublicLayout (no navbar), so it owns the full viewport.
    <Box
      sx={{
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #f8fbff, #ffffff)",
      }}
    >
      <Fade in timeout={600}>
        <Box sx={{ width: "100%" }}>
          <PublicFormCard icon={<LockClockRoundedIcon />} title="Session Expired" subtitle={MESSAGES.SESSION_EXPIRED} maxWidth={420}>
            <PublicFormButton startIcon={<LoginIcon />} onClick={() => navigate("/login")}>
              Log In Again
            </PublicFormButton>
            <Button fullWidth onClick={() => navigate("/")} sx={{ mt: 1, textTransform: "none", fontWeight: 500, borderRadius: 2 }}>
              Go to Home
            </Button>
          </PublicFormCard>
        </Box>
      </Fade>
    </Box>
  );
};
